/**
 * authStorage — session storage hygiene.
 *
 * Logging out (or a rejected token refresh after a backend restart) used to run
 * `localStorage.clear()`, which nuked EVERY client-side preference along with the
 * session: chart indicator toggles, per-symbol intervals/candle types, toolbar chip
 * ★ favourites, remembered zooms, collapsed groups, … — so each VPS restart
 * "reset the chart page to defaults". Only the AUTH keys belong to the session;
 * preferences belong to the DEVICE+ACCOUNT and must survive a re-login.
 *
 * Cross-account safety: when a DIFFERENT user logs in on this browser, the previous
 * account's client-side preferences ARE wiped (no cross-account bleed); the device
 * theme survives the switch.
 */
import { TOKEN_KEY, REFRESH_TOKEN_KEY, USER_KEY } from './constants';

export const LAST_USER_KEY = 'auth_lastUserId_v1';

/** Remove ONLY the session/auth keys — preferences survive a re-login. */
export function clearAuthStorage(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  } catch { /* storage unavailable — nothing to clear */ }
}

/** Call on every successful login BEFORE persisting the new session. If a
 *  different account than last time logs in, wipe the previous account's
 *  client-side preferences (keeping the device theme). */
export function noteLoggedInUser(userId: number | string | undefined | null): void {
  if (userId == null) return;
  try {
    const prev = localStorage.getItem(LAST_USER_KEY);
    if (prev != null && prev !== String(userId)) {
      const theme = localStorage.getItem('themeMode');
      localStorage.clear();
      if (theme) localStorage.setItem('themeMode', theme);
    }
    localStorage.setItem(LAST_USER_KEY, String(userId));
  } catch { /* storage unavailable */ }
}
